// # Calendar Filter Toggle Component
// Toggle switch for filtering calendar events by scope (All, My, Department)

'use client';

import React from 'react';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';

export type CalendarFilterType = 'all' | 'my' | 'my_department' | 'department';

interface CalendarFilterToggleProps {
  filter: CalendarFilterType;
  onChange: (filter: CalendarFilterType) => void;
  departmentName?: string;
  showDepartment?: boolean;
  showAll?: boolean;
}

export function CalendarFilterToggle({
  filter,
  onChange,
  departmentName,
  showDepartment = false,
  showAll = false
}: CalendarFilterToggleProps) {
  const { isMobile } = useDeviceInfo();
  const options: Array<{ value: CalendarFilterType; label: string }> = [];

  // Add "All" option if user has permission
  if (showAll) {
    options.push({ value: 'all', label: 'All' });
  }

  // Add "My Calendar" option (when not in department context, or as alternative)
  if (!showDepartment) {
    options.push({ value: 'my', label: 'My Calendar' });
  } else {
    // When in department context, show "My Department" instead
    options.push({ value: 'my_department', label: 'My Department' });
  }

  // Add "Department" option if in department context
  if (showDepartment && departmentName) {
    options.push({ 
      value: 'department', 
      label: departmentName 
    });
  }

  return (
    <div className={`flex items-center bg-gray-100 rounded-lg p-1 ${
      isMobile ? 'gap-1' : 'gap-2'
    }`}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`font-medium rounded-md transition-all duration-200 ${
            isMobile ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm'
          } ${
            filter === option.value
              ? 'bg-white text-gray-900 shadow-sm font-semibold'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default CalendarFilterToggle;

